var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{attrs:{"src":require(("@/assets/" + (this.source))),"alt":this.altText}})])}
var staticRenderFns = []

export { render, staticRenderFns }